
import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
  MenuItem,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import BookTable from "./BookTable"; // your existing form component
import api from '../services/api';

// Dummy tables


export default function AvailabilityPage() {
  const [date, setDate] = useState("2025-08-24");
  const [time, setTime] = useState("");
  const [pax, setPax] = useState("");
  const [available, setAvailable] = useState([]);
  const [checked, setChecked] = useState(false);
  const [times, setTimes] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  // For dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);

  // const times = ["18:00", "18:30", "19:00", "19:30", "20:00"];
  useEffect(() => {
    const fetchTimeSlots = async () => {
      try {
        const res = await api.get("/settings/time-slots");
        console.log(res.data.timeSlots)
        setTimes(res.data.timeSlots); // set fetched data to state
      } catch (err) {
        console.error("Error fetching time slots:", err);
      }
    };

    fetchTimeSlots();
  }, []);

  const checkAvailability = async () => {

    if (!date) {
      setError("Please select a date.");
      return;
    }

    if (!time) {
      setError("Please select a time.");
      return;
    }

    if (!pax) {
      setError("Please enter the number of guests (Pax).");
      return;
    }


    const response = await api.get('/tables/available', {
      params: {
        date: date,
        time: time,
        numberOfGuests: pax,
      },
    });
    console.log(response.data, "responseresponse")
setError("")
    setChecked(true);

    // let possibleTables = response.data.filter((t) => t.capacity >= pax);

    // const bookedIds = bookings
    //   .filter((b) => b.date === date && b.time === time)
    //   .map((b) => b.tableId);

    // possibleTables = possibleTables.filter((t) => !bookedIds.includes(t.id));

    setAvailable(response.data);
  };



  const handleBookNow = (table) => {

    //     {
    //     "_id": "688cf6bf3100a6da4e92b5fd",
    //     "tableNumber": "A3",
    //     "capacity": 6,
    //     "location": "indoor",
    //     "isAvailable": true,
    //     "description": "Large family table",
    //     "price": 0,
    //     "createdAt": "2025-08-01T17:17:51.210Z",
    //     "updatedAt": "2025-08-01T17:17:51.210Z",
    //     "__v": 0
    // }
    console.log(table)

    setSelectedTable(table);
    setOpenDialog(true);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Table Availability
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      {/* Filters */}
      <Box display="flex" gap={2} mb={3}>
      <TextField
  type="date"
  label="Date"
  value={date}
  onChange={(e) => setDate(e.target.value)}
  InputLabelProps={{ shrink: true }}
  inputProps={{
    min: dayjs().format("YYYY-MM-DD"), // today's date
  }}
/>
        <TextField
          select
          label="Time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          sx={{ minWidth: 120 }}
        >
          {times.map((t) => (
            <MenuItem key={t} value={t}>
              {dayjs(`2025-08-24T${t}`).format("hh:mm A")}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          type="number"
          label="Pax"
          value={pax}
          onChange={(e) => setPax(e.target.value)}
          sx={{ width: 100 }}
        />
        <Button variant="contained" onClick={checkAvailability}>
          Check
        </Button>
      </Box>

      {/* Results */}
      {checked && (
        <>

          {available.length > 0 ? (
            <Grid container spacing={2}>
              {available.map((table, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6">
                        Table {table.tableNumber}
                      </Typography>
                      <Typography>Capacity: {table.capacity}</Typography>
                      <Typography>Location: {table.location}</Typography>
                    </CardContent>
                    <CardActions>
                      <Button
                        variant="outlined"
                        onClick={() => handleBookNow(table)}
                      >
                        Book Now
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Alert severity="warning">
              No tables available at {time} for {pax} pax.
            </Alert>
          )}
        </>
      )}

      {/* Booking Form Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          Book Table – {selectedTable?.tableNumber}
          <IconButton
            onClick={() => setOpenDialog(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedTable && (
            <BookTable
              prefilled={{
                date,
                time,
                numberOfGuests: pax,
                table: selectedTable,

              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Container>
  );
}
